import { userService } from "../services";
import config from "../config/config";

export const PermissionAction = {
  fetchPermissionList,
  fetchPermissionListForAudit,
  fetchAllUserPermission,
  saveUserPermission,
  getTableHeadersVisibility,
  updateTableHeadersVisibility,
};

async function fetchPermissionList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.permission_category}`;
    //debugger
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchPermissionListForAudit(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.AllpermissionName}`;
    //debugger
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchAllUserPermission() {
  try {
    const apiEndPoint = `${
      JSON.parse(localStorage.getItem("config"))?.baseUrl
    }${config.apiName.getAllUserPermission}`;

    let response = await userService.get(apiEndPoint);
    if (response !== null) {
      return response;
    } else {
      console.log(response);
      // alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUserPermission(payload) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.savePermission
    }`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    } else if (response && response.status === 208) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function getTableHeadersVisibility(pageName, userId) {
  try {
    const apiEndPoint = `${
      JSON.parse(localStorage.getItem("config"))?.baseUrl
    }${config.apiName.tableHeadersVisibility}?pageName=${encodeURIComponent(
      pageName,
    )}&userId=${userId}`;

    let response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function updateTableHeadersVisibility(payload) {
  try {
    const apiEndPoint = `${
      JSON.parse(localStorage.getItem("config"))?.baseUrl
    }${config.apiName.updateTableHeadersVisibility}`;

    let response = await userService.post(apiEndPoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    } else {
      console.log(response);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
